import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		popularContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			marginBottom  : "2rem",
			width         : "100%",
			marginTop     : props?.activeTab === "all" ? "3rem" : "",

			[rooterMediaQuery.tablet]: {
				padding: "0 4rem"
			}

		},
		heading: {
			fontSize: "1.5rem",

			[rooterMediaQuery.mobile]: {
				marginBottom : "1rem",
				marginLeft   : "1.6rem"
			}
		},
		content: {
			display       : "flex",
			flexDirection : "column"
		}
	};
} );
